"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDesktop = exports.isTablet = exports.isMobile = exports.detectBreakpoint = exports.Breakpoint = void 0;
// Breakpoint enum for new screens
var Breakpoint;
(function (Breakpoint) {
    Breakpoint[Breakpoint["XXS"] = 0] = "XXS";
    Breakpoint[Breakpoint["XS"] = 1] = "XS";
    Breakpoint[Breakpoint["SM"] = 2] = "SM";
    Breakpoint[Breakpoint["MD"] = 3] = "MD";
    Breakpoint[Breakpoint["LG"] = 4] = "LG";
    Breakpoint[Breakpoint["XL"] = 5] = "XL";
    Breakpoint[Breakpoint["XXL"] = 6] = "XXL";
})(Breakpoint || (exports.Breakpoint = Breakpoint = {}));
const detectBreakpoint = (breakpoint) => {
    const width = window.innerWidth;
    switch (breakpoint) {
        // Mobile
        case Breakpoint.XXS:
            return width <= 360;
        case Breakpoint.XS:
            return width >= 360 && width < 600;
        case Breakpoint.SM:
            return width >= 600 && width < 720;
        // Tablet
        case Breakpoint.MD:
            return width >= 720 && width < 1024;
        // Desktop
        case Breakpoint.LG:
            return width >= 1024 && width < 1440;
        case Breakpoint.XL:
            return width >= 1440 && width < 1920;
        case Breakpoint.XXL:
            return width >= 1920;
        default:
            return false;
    }
};
exports.detectBreakpoint = detectBreakpoint;
const isMobile = () => {
    return ((0, exports.detectBreakpoint)(Breakpoint.XXS) ||
        (0, exports.detectBreakpoint)(Breakpoint.XS) ||
        (0, exports.detectBreakpoint)(Breakpoint.SM));
};
exports.isMobile = isMobile;
const isTablet = () => {
    return (0, exports.detectBreakpoint)(Breakpoint.MD);
};
exports.isTablet = isTablet;
const isDesktop = () => {
    return ((0, exports.detectBreakpoint)(Breakpoint.LG) ||
        (0, exports.detectBreakpoint)(Breakpoint.XL) ||
        (0, exports.detectBreakpoint)(Breakpoint.XXL));
};
exports.isDesktop = isDesktop;
